import request from '@/utils/request'
import requestJson from "@/utils/requestJson"

export function getListSupplier(data) {
  return request({
    url: '/admin/Ai_purchase/getListSupplier',
    method: 'get',
    params: data
  })
}


export function getSupplierList(data) {
  return request({
    url: '/admin/Ai_purchase/getSupplierList',
    method: 'get',
    params: data
  })
}
// 发起询价
export function createInquiry(data) {
  return request({
    url: '/admin/Ai_purchase/createInquiry',
    method: 'post',
    data
  })
}
// 询价单列表
export function getInquiryList(data) {
  return request({
    url: '/admin/Ai_purchase/getInquiryList',
    method: 'get',
    params: data
  })
}

export function getInquiryDetail(data) {
  return request({
    url: '/admin/Ai_purchase/getInquiryDetail',
    method: 'get',
    params: data
  })
}

// 删除询价商品
export function removeInquiryItem(data) {
  return request({
    url: '/admin/Ai_purchase/removeInquiryItem',
    method: 'post',
    data
  })
}
// 移除询价单
export function removeInquiry(data) {
  return request({
    url: '/admin/Ai_purchase/removeInquiry',
    method: 'post',
    data
  })
}


export function updateOrderStatus(data) {
  return request({
    url: '/admin/Ai_purchase/updateOrderStatus',
    method: 'post',
    data
  })
}

export function getListByRe(data) {
  return request({
    url: '/admin/zzs_common_log/getListByRe',
    method: 'get',
    params: data
  })
}

// 获取补货推荐量（replenish_diff_log 最新记录）
export function getReplenishRecommend(data) {
  return request({
    url: '/admin/pre_order_buy/getReplenishRecommend',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/pendingReplenishmentOrder.js